import {Component, OnInit} from "@angular/core";
import {Auth2Service} from "../../../../../services/auth2.service";
import {ApiService} from "../../../../../services/api.service";
import {UserService} from "../../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {SearchService} from "../../../../search-nonprofits-donors/services/search.service";
import {SearchGrantsService} from "../../../../search-grants/services/search-grants.service";
import {SearchIDsCriteriaDto} from "../../../../../models/search-ids-criteria-dto";
import {LoggedInPageBaseComponent} from "../../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-saved-searches-donor-create-edit',
  templateUrl: './saved-searches-donor-create-edit.component.html',
  styleUrls: ['./saved-searches-donor-create-edit.component.scss'],
  standalone: false
})
export class SavedSearchesDonorCreateEditComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Saved Searches', path: 'app/users/dashboard/saved-searches/all'},
    { label: 'Create / Edit Donor Saved Search'}
  ];

  //DONOR_SEARCH default, but there is also GRANT_SEARCH and NONPROFIT_SEARCH
  searchTypeName = "DONOR_SEARCH";

  currentSavedSearchDto: any = null;
  advancedFiltersButton: boolean = false;

  searchTypeNameMap: any = {};
  searchTypeNameLoadedFlag: boolean = false;
  affiliationCodeIdsLoadedFlag: boolean = false;
  deductabilityCodeIdsLoadedFlag: boolean = false;
  filingReqCodeIdsLoadedFlag: boolean = false;
  foundationCodeIdsLoadedFlag: boolean = false;
  nteeCodeIdsLoadedFlag: boolean = false;
  nteeParentCodeIdsLoadedFlag: boolean = false;
  organizationCodeIdsLoadedFlag: boolean = false;
  returnTypeCodeIdsLoadedFlag: boolean = false;
  totalAssetsLoadedFlag: boolean = false;
  totalIncomeLoadedFlag: boolean = false;
  causesLoadedFlag: boolean = false;

  savedSearchLoadedFlag: boolean = false;

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  readOnly: boolean = false;

  savedDonorSearchName: string = '';
  donor_names: string[] = [];
  donor_namesInput: string = '';
  donor_namesWithout: string[] = [];
  donor_namesWithoutInput: string = '';
  donor_eins: string[] = [];
  donor_einInput: string = '';
  includeTaxExemptRevoked: boolean = false;
  minYearsInBusiness: number = 0;
  donor_states: string[] = [];
  donor_stateInput: string = '';
  donor_cities: string[] = [];//will only be one
  donor_citiesInput: string = '';
  donor_citiesWithout: string[] = [];//will only be one
  donor_citiesWithoutInput: string = '';
  donor_donatedGrantsCities: string[] = [];//will only be one
  donor_donatedGrantsCitiesInput: string = '';
  donor_donatedGrantsStates: string[] = [];//will only be one
  donor_donatedGrantsStatesInput: string = '';
  taxYear: number = 0;
  donor_zipCodes: string[] = [];//will only be one
  donor_zipCodeInput: string = '';
  donor_counties: string[] = [];//will only be one
  donor_countiesInput: string = '';
  donor_countiesWithout: string[] = [];//will only be one
  donor_countiesWithoutInput: string = ''
  donor_affiliationCodeIds: number[] = [];
  donor_deductabilityCodeIds: number[] = [];
  donor_eoClassificationCodes: string[] = [];
  donor_eoSubsectionCodes: string[] = [];
  donor_filingReqCodeIds: number[] = [];
  donor_pfFilingReqCodeIds: number[] = [];
  donor_foundationCodeIds: number[] = [];
  donor_nteeCodeIds: number[] = [];
  donor_nteeParentCodeIds: number[] = [];
  donor_organizationCodeIds: number[] = [];
  donor_returnTypeCodeIds: number[] = [];
  donor_totalAssetsRange: number[] = [];// will always be just one if selected but the end result is 2 (a min and a max)
  donor_totalIncomeRange: number[] = [];
  donor_causes: string[] = [];
  donor_causeGivingInterestsList: string[] = [];
  donor_causeGivingInterestsWithoutList: string[] = [];
  donor_keyStaff: string[] = [];// will always be just one
  donor_keyStaffInput: string = '';
  donatedGrantsCities: string[] = [];
  donatedGrantsStates: string[] = [];

  donor_statesList: any[] = [];
  donor_citiesCheckboxes: any[] = [];
  donor_affiliationCodeCheckboxes: any[] = [];
  donor_affiliationCodeButton: boolean = false;

  donor_deductabilityCodeCheckboxes: any[] = [];
  donor_deductabilityCodeButton: boolean = false;

  donor_eoSubsectionClassificationCodeCheckboxes: any[] = [];
  donor_eoSubsectionClassificationCodeButton: boolean = false;

  donor_filingReqCodeCheckboxes: any[] = [];
  donor_filingReqCodeButton: boolean = false;

  donor_pfFilingReqCodeCheckboxes: any[] = [];
  donor_pfFilingReqCodeButton: boolean = false;

  donor_foundationCodeCheckboxes: any[] = [];
  donor_foundationCodeButton: boolean = false;

  donor_nteeCodeCheckboxes: any[] = [];
  donor_nteeCodeButton: boolean = false;

  donor_nteeParentCodeCheckboxes: any[] = [];
  donor_nteeParentCodeButton: boolean = false;

  donor_organizationCodeCheckboxes: any[] = [];
  donor_organizationCodeButton: boolean = false;

  donor_returnTypeCodeCheckboxes: any[] = [];
  donor_returnTypeCodeButton: boolean = false;

  donor_totalAssetsRadioButtons: any[] = [];
  donor_totalAssetsButton: any = false;

  donor_totalIncomeRadioButtons: any[] = [];
  donor_totalIncomeButton: any = false;

  donor_causesRadioButtons: any[] = [];
  donor_causesButton: any = false;

  causeDropdownList: any[] = [];
  causeGivingInterestsDropdownList: any[] = [];

  donor_givingInterestsSetObj: any = {};
  donor_givingInterestsWithoutSetObj: any = {};

  donor_causeGivingInterestsSetObj: any = {};

  browserUrl: string = '';

  logicalOperatorAnd: boolean = false;
  logicalOperatorOr: boolean = true;

  companyNameAscRadioButton: boolean = false;
  companyNameDescRadioButton: boolean = false;
  cityAscRadioButton: boolean = false;
  cityDescRadioButton: boolean = false;
  stateAscRadioButton: boolean = false;
  stateDescRadioButton: boolean = false;
  totalAssetsAscRadioButton: boolean = false;
  totalAssetsDescRadioButton: boolean = false;

  sortByCompanyNameAscId: number = 0;
  sortByCityAscId: number = 0;
  sortByStateAscId: number = 0;
  sortByTotalAssetsAscId: number = 0;

  keyStaffAutocomplete: any[] = [];
  companyNamesAutocomplete: any[] = [];
  citiesAutocomplete: any[] = [];

  taxYears: any[] = [
    {"taxYear": 2025},{"taxYear": 2024}, {"taxYear": 2023}, {"taxYear": 2022}, {"taxYear": 2021}, {"taxYear": 2020}
  ];

  //Needs pop up for SavedSearch Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService : UserService,
              private searchService: SearchService, private searchGrantsService: SearchGrantsService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Create or Edit Donor Saved Search");
  }

  populateDonorCities(): void {
    // @ts-ignore
    let donorCitiesCacheExpTimeStr: string = localStorage.getItem('donorCitiesCacheExpTime');
    if (!donorCitiesCacheExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('donorCitiesCache');
    } else {
      let donorCitiesExpTime: number = parseInt(donorCitiesCacheExpTimeStr);
      let now = Date.now();
      if (now >= donorCitiesExpTime) {
        //expire the cached search
        localStorage.removeItem('donorCitiesCache');
      }
    }
    const donorCitiesCacheJsonString = localStorage.getItem('donorCitiesCache');
    if (!donorCitiesCacheJsonString) {
      this.searchService.getDonorsCities(this.username).subscribe((result: any) => {
        if (result && result.body) {
          let i: number = 0;
          while (i < result.body.size) {
            this.citiesAutocomplete.push(result.body.citiesStates[i]);
            i = i + 1;
          }
          let expirationTimestamp: number = Date.now() + 1000*3600*8;
          localStorage.setItem('donorCitiesCacheExpTime', expirationTimestamp.toString());
          localStorage.setItem('donorCitiesCache', JSON.stringify(this.citiesAutocomplete));
        }
      }, (error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Donors Error',
          detail: 'Failed to pull Donor cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
    } else {
      this.citiesAutocomplete = JSON.parse(donorCitiesCacheJsonString);
    }
  }

  populateDonorCompanyNames(): void {
    this.searchService.getDonorsCompanyNames(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.companyNamesAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Donors Error',
        detail: 'Failed to pull Donor company names.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  toggleAdvancedFilters(): any {
    this.advancedFiltersButton = !this.advancedFiltersButton;
  }

  populateDonorKeyStaff(): void {
    this.searchService.getDonorsKeyStaff(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.keyStaffAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Donors Error',
        detail: 'Failed to pull Donor Key Staff.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }
  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    this.browserUrl = window.location.href;
    this.readOnly = this.apiService.calculateReadOnly(this.browserUrl, this.impersonatedEmail, this.consultantRoleName);
    if (this.browserUrl.includes('view')) {
      this.titleService.setTitle("Scalanthropy View Donor Saved Search");
      this.breadCrumbs[4] = { label: 'View Donor Saved Search'};
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.searchTypeNameLoadedFlag = false;
    //this.affiliationCodeIdsLoadedFlag = false;
    //this.deductabilityCodeIdsLoadedFlag = false;
    this.filingReqCodeIdsLoadedFlag = false;
    this.foundationCodeIdsLoadedFlag = false;
    this.nteeCodeIdsLoadedFlag = false;
    this.nteeParentCodeIdsLoadedFlag = false;
    this.organizationCodeIdsLoadedFlag = false;
    this.returnTypeCodeIdsLoadedFlag = false;
    this.totalAssetsLoadedFlag = false
    this.causesLoadedFlag = false;

    this.savedSearchLoadedFlag = false;

    this.loadSearchTypeNameMap();
    if(this.browserUrl.includes('view')) {
      const currentSavedSearchId = this.route.snapshot.paramMap.get('savedSearchId');
      // @ts-ignore
      this.userService.getSavedSearch(currentSavedSearchId, this.username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            //Distribute the saved search parameters to the radioboxes,checkboxes, and textboxes
            this.loadSavedDonorSearchParams();
            this.savedSearchLoadedFlag = true;
          }
          return;
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Saved Search API Failure',
            detail: 'Failed to download the savedSearchId: ' + currentSavedSearchId,
            severity: 'error'
          });
          this.showErrorMessagesToUser();
          return;
        }
      );
    } else {
      this.populateUSAStates();
      this.populateDonorCities();
      this.populateDonorCompanyNames();
      this.populateDonorKeyStaff();

      //this.populateAffiliationCodeCheckboxes(); Not currently used
      //this.populateDeductabilityCodeCheckboxes(); Not currently used
      this.populateFoundationCodeCheckboxes();
      this.populateFilingReqCodeCheckboxes();
      this.populateNteeCodeCheckboxes();
      this.populateNteeParentCodeCheckboxes();
      this.populateOrganizationCodeCheckboxes();
      this.populateReturnTypeCodeCheckboxes();
      this.populateTotalAssetsRangeRadioButtons();
      this.populateTotalIncomeRangeRadioButtons();
      this.populateCausesDropdown();
      this.populateCauseGivingInterestsDropdown();
      //retries
      let retries_limit = 4;
      let count = 0;
      while (count < retries_limit) {
        setTimeout(() => {
          if (this.savedSearchLoadedFlag) {
            return;
          }
          if (this.searchTypeNameLoadedFlag && this.foundationCodeIdsLoadedFlag && this.filingReqCodeIdsLoadedFlag &&
            this.nteeCodeIdsLoadedFlag && this.nteeParentCodeIdsLoadedFlag && this.organizationCodeIdsLoadedFlag &&
            this.returnTypeCodeIdsLoadedFlag && this.totalAssetsLoadedFlag && this.causesLoadedFlag) {
            this.browserUrl = window.location.href;
            if (this.browserUrl.includes('edit') || this.browserUrl.includes('view')) {
              //extract the id from the browser url
              const currentSavedSearchId = this.route.snapshot.paramMap.get('savedSearchId');
              //load the saved search from the database
              // @ts-ignore
              this.userService.getSavedSearch(currentSavedSearchId, this.username, this.impersonatedEmail).subscribe(
                (result: any) => {
                  if (result && result.body) {
                    this.currentSavedSearchDto = result.body;
                    //Distribute the saved search parameters to the radioboxes,checkboxes, and textboxes
                    this.loadSavedDonorSearchParams();
                    this.savedSearchLoadedFlag = true;
                  }
                }, (err: HttpErrorResponse) => {
                  this.redirectToLogin(err);
                  this.pageErrorMessages.push({
                    field: 'Saved Search API Failure',
                    detail: 'Failed to download the savedSearchId: ' + currentSavedSearchId,
                    severity: 'error'
                  });
                  this.showErrorMessagesToUser();
                }
              );
            }
          }
        }, 8000);
        count = count + 1;
      };
    }
  }

  loadSavedDonorSearchParams(): void {
    //Assumes
    if (this.currentSavedSearchDto.savedSearchName) {
      this.savedDonorSearchName = this.currentSavedSearchDto.savedSearchName;
    }
    if (this.currentSavedSearchDto.savedSearchJson) {
      let donorSearchJson: any = JSON.parse(this.currentSavedSearchDto.savedSearchJson);
      if (donorSearchJson['names'] && donorSearchJson['names'].length > 0) {
        this.donor_namesInput = donorSearchJson['names'].join(',');
        const donorNameInputEl = document.getElementById('donor-name-with-text-id');
        // @ts-ignore
        donorNameInputEl.value = this.donor_namesInput;

      }
      /*
      if (donorSearchJson['namesWithout'] && donorSearchJson['namesWithout'].length > 0) {
        this.donor_namesWithoutInput = donorSearchJson['namesWithout'].join(',');
      }*/
      if (donorSearchJson['eins'] && donorSearchJson['eins'].length > 0) {
        this.donor_einInput = donorSearchJson['eins'].join(',');
      }
      if (donorSearchJson['states'] && donorSearchJson['states'].length > 0) {
        if (!this.readOnly) {
          const usaStatesEl = document.getElementById('usa-dropdown-list-id');
          // @ts-ignore
          usaStatesEl.value = donorSearchJson['states'][0];
        } else {
          const usaStatesEl = document.getElementById('usa-state-text-id');
          // @ts-ignore
          usaStatesEl.value = donorSearchJson['states'][0];
        }

      }
      if (donorSearchJson['cities'] && donorSearchJson['cities'].length > 0) {
        this.donor_citiesInput = donorSearchJson['cities'].join(',');
        console.log('this.donor_citiesInput: ' + this.donor_citiesInput);
      }
      /*
      if (donorSearchJson['citiesWithout'] && donorSearchJson['citiesWithout'].length > 0) {
        this.donor_citiesWithoutInput = donorSearchJson['citiesWithout'].join(',');
      }*/


      if (donorSearchJson['donatedGrantsCities'] && donorSearchJson['donatedGrantsCities'].length > 0) {
        this.donor_donatedGrantsCitiesInput = donorSearchJson['donatedGrantsCities'].join(',');
      }

      if (donorSearchJson['donatedGrantsStates'] && donorSearchJson['donatedGrantsStates'].length > 0) {
        if (!this.readOnly) {
          const donatedGrantsStatesEl = document.getElementById('donated-grants-states-dropdown-list-id');
          // @ts-ignore
          donatedGrantsStatesEl.value = donorSearchJson['donatedGrantsStates'][0];
        } else {
          const donatedGrantsStatesEl = document.getElementById('dg-usa-state-text-id');
          // @ts-ignore
          donatedGrantsStatesEl.value = donorSearchJson['donatedGrantsStates'][0];
        }
      }

      if (donorSearchJson['taxYear']) {
        if (!this.readOnly) {
          const taxYearDropdownEl = document.getElementById('tax-year-dropdown-list-id');
          // @ts-ignore
          taxYearDropdownEl.value = donorSearchJson['taxYear'];
        } else {
          const taxYearDropdownEl = document.getElementById('tax-year-text-id');
          // @ts-ignore
          taxYearDropdownEl.value = donorSearchJson['taxYear'];
        }
      }

      if (donorSearchJson['zipCodes'] && donorSearchJson['zipCodes'].length > 0) {
        this.donor_zipCodeInput = donorSearchJson['zipCodes'][0];
      }
      /*
      if (donorSearchJson['counties'] && donorSearchJson['counties'].length > 0) {
        this.donor_countiesInput = donorSearchJson['counties'][0];
      }
      if (donorSearchJson['countiesWithout'] && donorSearchJson['countiesWithout'].length > 0) {
        this.donor_countiesWithoutInput = donorSearchJson['countiesWithout'][0];
      }*/

      if (donorSearchJson['keyStaff'] && donorSearchJson['keyStaff'].length > 0) {
        this.donor_keyStaffInput = donorSearchJson['keyStaff'][0];
        this.advancedFiltersButton = true;
      }
      if (donorSearchJson['filingReqCodeIds'] && donorSearchJson['filingReqCodeIds'].length > 0) {
        for (const filingReqCodeId of donorSearchJson['filingReqCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_filingReqCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.donor_filingReqCodeCheckboxes[i].filingReqCodeId === filingReqCodeId) {
              this.donor_filingReqCodeCheckboxes[i].checked = true;
              this.donor_filingReqCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['foundationCodeIds'] && donorSearchJson['foundationCodeIds'].length > 0) {
        for (const foundationCodeId of donorSearchJson['foundationCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_foundationCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.donor_foundationCodeCheckboxes[i].foundationCodeId === foundationCodeId) {
              this.donor_foundationCodeCheckboxes[i].checked = true;
              this.donor_foundationCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['nteeCodeIds'] && donorSearchJson['nteeCodeIds'].length > 0) {
        for (const nteeCodeId of donorSearchJson['nteeCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_nteeCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.donor_nteeCodeCheckboxes[i].nteeCodeId === nteeCodeId) {
              this.donor_nteeCodeCheckboxes[i].checked = true;
              this.donor_nteeCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['nteeParentCodeIds'] && donorSearchJson['nteeParentCodeIds'].length > 0) {
        for (const nteeParentCodeId of donorSearchJson['nteeParentCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_nteeParentCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.donor_nteeParentCodeCheckboxes[i].nteeParentCodeId === nteeParentCodeId) {
              this.donor_nteeParentCodeCheckboxes[i].checked = true;
              this.donor_nteeParentCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['organizationCodeIds'] && donorSearchJson['organizationCodeIds'].length > 0) {
        for (const organizationCodeId of donorSearchJson['organizationCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_organizationCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.donor_organizationCodeCheckboxes[i].organizationCodeId === organizationCodeId) {
              this.donor_organizationCodeCheckboxes[i].checked = true;
              this.donor_organizationCodeButton = true;
            }
            i = i + 1;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['returnTypeCodeIds'] && donorSearchJson['returnTypeCodeIds'].length > 0) {
        for (const returnTypeCodeId of donorSearchJson['returnTypeCodeIds']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_returnTypeCodeCheckboxes.length;
          while (i < affCodeLength) {
            if (this.donor_returnTypeCodeCheckboxes[i].returnTypeCodeId === returnTypeCodeId) {
              this.donor_returnTypeCodeCheckboxes[i].checked = true;
              this.donor_returnTypeCodeButton = true;
            }
            i = i + 1;
          }
        }
      }

      if (donorSearchJson['totalAssetsRange'] && donorSearchJson['totalAssetsRange'].length > 0) {
        for (const assetRangeObj of this.donor_totalAssetsRadioButtons) {
          let i: number = 0;
          if (assetRangeObj.minTotalAssets === donorSearchJson['totalAssetsRange'][0]
            && assetRangeObj.maxTotalAssets === donorSearchJson['totalAssetsRange'][1]) {
            assetRangeObj.checked = true;
            this.donor_totalAssetsButton = true;
            break;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['totalIncomeRange'] && donorSearchJson['totalIncomeRange'].length > 0) {
        for (const incomeRangeObj of this.donor_totalIncomeRadioButtons) {
          let i: number = 0;
          if (incomeRangeObj.minTotalIncome === donorSearchJson['totalIncomeRange'][0]
            && incomeRangeObj.maxTotalIncome === donorSearchJson['totalIncomeRange'][1]) {
            incomeRangeObj.checked = true;
            this.donor_totalIncomeButton = true;
            break;
          }
        }
        this.advancedFiltersButton = true;
      }

      if (donorSearchJson['causes'] && donorSearchJson['causes'].length > 0) {
        for (const cause of donorSearchJson['causes']) {
          let i: number = 0;
          let affCodeLength: number = this.donor_causesRadioButtons.length;
          while (i < affCodeLength) {
            if (this.donor_causesRadioButtons[i].causeName === cause) {
              this.donor_causesRadioButtons[i].checked = true;
              break;
            }
            i = i + 1;
          }
        }
      }

      this.donor_causeGivingInterestsList = [];
      if (donorSearchJson['causeGivingInterests'] && donorSearchJson['causeGivingInterests'].length > 0) {
        for (const causeGivingInterest of donorSearchJson['causeGivingInterests']) {
          this.donor_causeGivingInterestsList.push(causeGivingInterest);
        }
      }

      this.donor_causeGivingInterestsWithoutList = [];
      /*
      if (donorSearchJson['causeGivingInterestsWithout'] && donorSearchJson['causeGivingInterestsWithout'].length > 0) {
        for (const causeGivingInterest of donorSearchJson['causeGivingInterestsWithout']) {
          this.donor_causeGivingInterestsWithoutList.push(causeGivingInterest);
        }
      }*/

      if (donorSearchJson['sortByCompanyNameAsc']) {
        this.companyNameAscRadioButton = false;
        this.companyNameDescRadioButton = false;
        if (donorSearchJson['sortByCompanyNameAsc'] == 1) {
          this.companyNameAscRadioButton = true;
        } else if (donorSearchJson['sortByCompanyNameAsc'] == 2) {
          this.companyNameDescRadioButton = true;
        }
      }

      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      if (donorSearchJson['sortByCityAsc']) {
        if (donorSearchJson['sortByCityAsc'] == 1) {
          this.cityAscRadioButton = true;
        } else if (donorSearchJson['sortByCityAsc'] == 2) {
          this.cityDescRadioButton = true;
        }
      }

      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      if (donorSearchJson['sortByStateAsc']) {
        if (donorSearchJson['sortByStateAsc'] == 1) {
          this.stateAscRadioButton = true;
        } else if (donorSearchJson['sortByStateAsc'] == 2) {
          this.stateDescRadioButton = true;
        }
      }

      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
      if (donorSearchJson['sortByTotalAssetsAsc']) {
        if (donorSearchJson['sortByTotalAssetsAsc'] == 1) {
          this.totalAssetsAscRadioButton = true;
        } else if (donorSearchJson['sortByTotalAssetsAsc'] == 2) {
          this.totalAssetsDescRadioButton = true;
        }
      }
    }
    this.openSearchTypeFilters(null, this.searchTypeName);
  }

  deleteGivingInterestChip(givingInterestChipStr : string, parentElement: any): void {
    parentElement.style.display = 'none';
    delete this.donor_givingInterestsSetObj[givingInterestChipStr];
  }

  deleteGivingInterestWithoutChip(givingInterestWithoutChipStr : string, parentElement: any): void {
    parentElement.style.display = 'none';
    delete this.donor_givingInterestsWithoutSetObj[givingInterestWithoutChipStr];
  }

  loadSearchTypeNameMap(): void {
    this.searchService.getSearchTypeNamesDropdown(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          for (const searchTypeNameTemp of result.body){
            this.searchTypeNameMap[searchTypeNameTemp.searchTypeName] = searchTypeNameTemp.searchTypeId;
          }
          this.searchTypeNameLoadedFlag = true;
        }
        return;
    }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Saved Search API Failure',
          detail: 'Failed to pull the Search Type Names',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
        this.searchTypeNameLoadedFlag = false;
        return;
      });
    this.searchTypeNameLoadedFlag = false;
    return;
  }

  resetFilters() {
    const donorNameInputEl = document.getElementById('donor-name-with-text-id');
    // @ts-ignore
    donorNameInputEl.value = '';
    //const donorNameWithoutInputEl = document.getElementById('donor-name-without-text-id');
    // @ts-ignore
    //donorNameWithoutInputEl.value = '';
    const donorEinInputEl = document.getElementById('donor-ein-text-id');
    // @ts-ignore
    donorEinInputEl.value = '';
    const donorCitiesInputEl = document.getElementById('donor-cities-text-id');
    // @ts-ignore
    donorCitiesInputEl.value = '';
    //const donorCitiesWithoutInputEl = document.getElementById('donor-cities-without-text-id');
    // @ts-ignore
    //donorCitiesWithoutInputEl.value = '';
    const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    usaStateDropdownEl.value = '';
    const donorZipCodeInputEl = document.getElementById('donor-zip-code-text-id');
    // @ts-ignore
    donorZipCodeInputEl.value = '';

    // @ts-ignore
    const dgCitiesInputEl = document.getElementById('donated-grants-cities-text-id');
    // @ts-ignore
    dgCitiesInputEl.value = '';
    const dgUsaStateDropdownEl = document.getElementById('dg-usa-dropdown-list-id');
    // @ts-ignore
    dgUsaStateDropdownEl.value = '';
    const taxYearDropdownEl = document.getElementById('tax-year-dropdown-list-id');
    // @ts-ignore
    taxYearDropdownEl.value = '';
    /*
    const donorCountiesInputEl = document.getElementById('donor-counties-text-id');
    // @ts-ignore
    donorCountiesInputEl.value = '';
    const donorCountiesWithoutInputEl = document.getElementById('donor-counties-without-text-id');
    // @ts-ignore
    donorCountiesWithoutInputEl.value = '';
     */
    const donorKeyStaffInputEl = document.getElementById('donor-key-staff-text-id');
    // @ts-ignore
    donorKeyStaffInputEl.value = '';

    this.donor_namesInput = '';
    this.donor_einInput = '';
    this.donor_citiesInput = '';
    this.donor_citiesWithoutInput = '';
    this.donor_zipCodeInput = '';
    this.donor_countiesInput = '';
    this.donor_countiesWithoutInput = '';
    this.donor_keyStaffInput = '';

    this.minYearsInBusiness = 0;
    //const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    // @ts-ignore
    //minYearsInBusinessEl.value = '';
    this.includeTaxExemptRevoked = false;

    for(const donor_affiliationCodeCheckbox of this.donor_affiliationCodeCheckboxes) {
      donor_affiliationCodeCheckbox.checked = false;
    }

    for(const donor_deductabilityCodeCheckbox of this.donor_deductabilityCodeCheckboxes) {
      donor_deductabilityCodeCheckbox.checked = false;
    }

    for(const donor_filingReqCodeCheckbox of this.donor_filingReqCodeCheckboxes) {
      donor_filingReqCodeCheckbox.checked = false;
    }

    for(const donor_foundationCodeCheckbox of this.donor_foundationCodeCheckboxes) {
      donor_foundationCodeCheckbox.checked = false;
    }

    for(const donor_nteeCodeCheckbox of this.donor_nteeCodeCheckboxes) {
      donor_nteeCodeCheckbox.checked = false;
    }

    for(const donor_nteeParentCodeCheckbox of this.donor_nteeParentCodeCheckboxes) {
      donor_nteeParentCodeCheckbox.checked = false;
    }

    for(const donor_organizationCodeCheckbox of this.donor_organizationCodeCheckboxes) {
      donor_organizationCodeCheckbox.checked = false;
    }

    for(const donor_totalAssetsRadioButton of this.donor_totalAssetsRadioButtons) {
      donor_totalAssetsRadioButton.checked = false;
    }

    for(const donor_totalIncomeRadioButton of this.donor_totalIncomeRadioButtons) {
      donor_totalIncomeRadioButton.checked = false;
    }

    this.donor_givingInterestsSetObj = {};
    this.donor_causeGivingInterestsList =[];
    this.donor_givingInterestsWithoutSetObj = {};
    this.donor_causeGivingInterestsWithoutList = [];

    const causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    causeCategorySel.value = '';

    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    causeGivingInterestEl.value = '';

    this.companyNameAscRadioButton = false;
    this.companyNameDescRadioButton = false;
    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    this.totalAssetsAscRadioButton = false;
    this.totalAssetsDescRadioButton = false;

    this.sortByCompanyNameAscId = 0;
    this.sortByCityAscId = 0;
    this.sortByStateAscId = 0;
    this.sortByTotalAssetsAscId = 0;
  }

  loadFilters(): boolean {
    this.populateUSAStates();
    this.populateAffiliationCodeCheckboxes();
    this.populateDeductabilityCodeCheckboxes();
    this.populateFoundationCodeCheckboxes();
    this.populateFilingReqCodeCheckboxes();
    this.populateNteeCodeCheckboxes();
    this.populateNteeParentCodeCheckboxes();
    this.populateOrganizationCodeCheckboxes();
    this.populateReturnTypeCodeCheckboxes();
    this.populateTotalAssetsRangeRadioButtons();
    this.populateTotalIncomeRangeRadioButtons();
    this.populateCausesDropdown();
    return true;
  }

  populateUSAStates(): void {
    this.donor_statesList = [];
    this.searchService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        //this.statesList = result.body;
        let i: number = 0;
        while (i < result.body.length) {
          this.donor_statesList.push(result.body[i]);
          i = i + 1;
        }
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the USA States...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      return;
    })
    return;
  }

  toggleDonorAffiliationCodesFilter(): void {
    this.donor_affiliationCodeButton = !this.donor_affiliationCodeButton;
  }

  addValToDonorAffiliationCodes(idValue:number): void {
    const donorAffiliationCodeEl = document.getElementById('flexCheckCheckedDonorAffiliationCode-' + idValue);
    // @ts-ignore
    this.donor_affiliationCodeCheckboxes[idValue]['checked'] = donorAffiliationCodeEl.checked;
  }

  populateAffiliationCodeCheckboxes(): void {
    this.searchService.getAffiliationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_affiliationCodeCheckboxes = result.body;
        this.affiliationCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Affiliation Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.affiliationCodeIdsLoadedFlag = false;
      return;
    })
    this.affiliationCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorDeductabilityCodesFilter(): void {
    this.donor_deductabilityCodeButton = !this.donor_deductabilityCodeButton;
  }

  addValToDonorDeductabilityCodes(idValue:number): void {
    const donorDeductabilityCodeEl = document.getElementById('flexCheckCheckedDonorDeductabilityCode-' + idValue);
    // @ts-ignore
    this.donor_deductabilityCodeCheckboxes[idValue]['checked'] = donorDeductabilityCodeEl.checked;
  }

  populateDeductabilityCodeCheckboxes(): void {
    this.searchService.getDeductibilityCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_deductabilityCodeCheckboxes = result.body;
        this.deductabilityCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Deductability Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.deductabilityCodeIdsLoadedFlag = false;
      return;
    });
    this.deductabilityCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorFilingReqCodesFilter(): void {
    this.donor_filingReqCodeButton = !this.donor_filingReqCodeButton;
  }

  addValToDonorFilingReqCodes(idValue:number): void {
    const donorFilingReqCodeEl = document.getElementById('flexCheckCheckedDonorFilingReqCode-' + idValue);
    // @ts-ignore
    this.donor_filingReqCodeCheckboxes[idValue]['checked'] = donorFilingReqCodeEl.checked;
  }

  populateFilingReqCodeCheckboxes(): void {
    this.searchService.getFilingReqCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_filingReqCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.donor_filingReqCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.filingReqCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Filing Req Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.filingReqCodeIdsLoadedFlag = false;
      return;
    });
    this.filingReqCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorFoundationCodesFilter(): void {
    this.donor_foundationCodeButton = !this.donor_foundationCodeButton;
  }

  addValToDonorFoundationCodes(idValue:number): void {
    const donorFoundationCodeEl = document.getElementById('flexCheckCheckedDonorFoundationCode-' + idValue);
    // @ts-ignore
    this.donor_foundationCodeCheckboxes[idValue]['checked'] = donorFoundationCodeEl.checked;
  }

  populateFoundationCodeCheckboxes(): void {
    this.searchService.getFoundationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_foundationCodeCheckboxes = [];
        let i : number = 0;
        while (i < result.body.length) {
          this.donor_foundationCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.foundationCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Foundation Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.foundationCodeIdsLoadedFlag = false;
      return;
    });
    this.foundationCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorNteeCodesFilter(): void {
    this.donor_nteeCodeButton = !this.donor_nteeCodeButton;
  }

  addValToDonorNteeCodes(idValue:number): void {
    const nteeCodeEl = document.getElementById('flexCheckCheckedDonorNteeCode-' + idValue);
    // @ts-ignore
    this.donor_nteeCodeCheckboxes[idValue]['checked'] = nteeCodeEl.checked;
  }

  populateNteeCodeCheckboxes(): void {
    this.searchService.getNteeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_nteeCodeCheckboxes = [];
        let i : number = 0;
        while (i < result.body.length) {
          this.donor_nteeCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.nteeCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Ntee Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.nteeCodeIdsLoadedFlag = false;
      return;
    });
    this.nteeCodeIdsLoadedFlag = false;
    return;
  }
  toggleDonorNteeParentCodesFilter(): void {
    this.donor_nteeParentCodeButton = !this.donor_nteeParentCodeButton;
  }

  addValToDonorNteeParentCodes(idValue:number): void {
    const nteeParentCodeEl = document.getElementById('flexCheckCheckedDonorNteeParentCode-' + idValue);
    // @ts-ignore
    this.donor_nteeParentCodeCheckboxes[idValue]['checked'] = nteeParentCodeEl.checked;
  }

  populateNteeParentCodeCheckboxes(): void {
    this.searchService.getNteeParentCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_nteeParentCodeCheckboxes = [];
        let i : number = 0;
        while (i < result.body.length) {
          this.donor_nteeParentCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.nteeParentCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Ntee Parent Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.nteeParentCodeIdsLoadedFlag = false;
      return;
    });
    this.nteeParentCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorOrganizationCodesFilter(): void {
    this.donor_organizationCodeButton = !this.donor_organizationCodeButton;
  }
  addValToDonorOrganizationCodes(idValue:number): void {
    const organizationCodeEl = document.getElementById('flexCheckCheckedDonorOrganizationCode-' + idValue);
    // @ts-ignore
    this.donor_organizationCodeCheckboxes[idValue]['checked'] = organizationCodeEl.checked;
  }

  populateOrganizationCodeCheckboxes(): void {
    this.searchService.getOrganizationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_organizationCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.donor_organizationCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        this.organizationCodeIdsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Organization Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.organizationCodeIdsLoadedFlag = false;
      return;
    });
    this.organizationCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorReturnTypeCodesFilter(): void {
    this.donor_returnTypeCodeButton = !this.donor_returnTypeCodeButton;
  }

  addValToDonorReturnTypeCodes(idValue:number): void {
    const returnTypeCodeEl = document.getElementById('flexCheckCheckedDonorReturnTypeCode-' + idValue);
    // @ts-ignore
    this.donor_returnTypeCodeCheckboxes[idValue]['checked'] = returnTypeCodeEl.checked;
  }

  populateReturnTypeCodeCheckboxes(): void {
    this.searchService.getReturnTypeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_returnTypeCodeCheckboxes = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.donor_returnTypeCodeCheckboxes.push(result.body[i]);
          i = i + 1;
        }
        let j: number = 0;

        this.returnTypeCodeIdsLoadedFlag = true;
        for ( const returnTypeCodeCheckboxTemp2 of this.donor_returnTypeCodeCheckboxes) {
          if (returnTypeCodeCheckboxTemp2['returnTypeCodeName'] === '990PF') {
            returnTypeCodeCheckboxTemp2['checked'] = true;
          } else {
            returnTypeCodeCheckboxTemp2['checked'] = false;
          }
        }
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Return Type Codes...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.returnTypeCodeIdsLoadedFlag = false;
      return;
    });
    this.returnTypeCodeIdsLoadedFlag = false;
    return;
  }

  toggleDonorTotalAssetsFilter(): any {
    this.donor_totalAssetsButton = !this.donor_totalAssetsButton;
  }

  trackDonorTotalAssetsRange(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.donor_totalAssetsRadioButtons) {
      if (this.donor_totalAssetsRadioButtons[idValue]['checked']) {
        continue;
      } else {
        radioButton.checked = false;
      }
    }
    const totalAssetsRangeEl = document.getElementById('flexRadioDonorTotalAssets-' + idValue);
    this.donor_totalAssetsRadioButtons[idValue]['checked'] = !this.donor_totalAssetsRadioButtons[idValue]['checked'];
    // @ts-ignore
    totalAssetsRangeEl.checked = this.donor_totalAssetsRadioButtons[idValue]['checked']
  }

  populateTotalAssetsRangeRadioButtons(): void {
    this.searchService.getTotalAssetsRangeDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_totalAssetsRadioButtons = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.donor_totalAssetsRadioButtons.push(result.body[i]);
          i = i + 1;
        }
        this.totalAssetsLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Total Assets Filters...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.totalAssetsLoadedFlag = false;
      return;
    });
    this.totalAssetsLoadedFlag = false;
    return;
  }

  toggleDonorTotalIncomeFilter(): any {
    this.donor_totalIncomeButton = !this.donor_totalIncomeButton;
  }

  trackDonorTotalIncomeRange(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.donor_totalIncomeRadioButtons) {
      if (this.donor_totalIncomeRadioButtons[idValue]['checked']) {
        continue;
      } else {
        radioButton.checked = false;
      }
    }
    const totalIncomeRangeEl = document.getElementById('flexRadioDonorTotalIncome-' + idValue);
    this.donor_totalIncomeRadioButtons[idValue]['checked'] = !this.donor_totalIncomeRadioButtons[idValue]['checked'];
    // @ts-ignore
    totalIncomeRangeEl.checked = this.donor_totalIncomeRadioButtons[idValue]['checked']
  }
  populateTotalIncomeRangeRadioButtons(): void {
    this.searchService.getTotalIncomeRangeDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_totalIncomeRadioButtons = [];
        let i: number = 0;
        while (i < result.body.length) {
          this.donor_totalIncomeRadioButtons.push(result.body[i]);
          i = i + 1;
        }
        this.totalIncomeLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Total Income Filter...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.totalIncomeLoadedFlag = false;
      return;
    });
    this.totalIncomeLoadedFlag = false;
    return;
  }

  populateCausesDropdown(): void {
    this.searchService.getCausesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body
        this.causesLoadedFlag = true;
      }
      return;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Cause Categories...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.causesLoadedFlag = false;
      return;
    });
    this.causesLoadedFlag = false;
    return;
  }

  updateCauseGivingInterestsDropdown(): boolean {
    var causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    let causeCategorySelVal = causeCategorySel.value;
    if (causeCategorySel) {
      if (this.donor_causeGivingInterestsSetObj[causeCategorySelVal]) {
        this.causeGivingInterestsDropdownList = this.donor_causeGivingInterestsSetObj[causeCategorySelVal];
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsDropdownList.concat(
          [{givingInterestDisplayName: 'All Other Cause Category Giving Interests', givingInterestName: 'ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' }], this.donor_causeGivingInterestsSetObj['ALL'])
      } else {
        this.causeGivingInterestsDropdownList = this.donor_causeGivingInterestsSetObj["ALL"];
      }
    }
    return true;
  }

  populateCauseGivingInterestsDropdown(): void {
    this.searchService.getAllGivingInterestsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donor_causeGivingInterestsSetObj = result.body;
        this.causeGivingInterestsDropdownList = this.donor_causeGivingInterestsSetObj["ALL"];
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Failed to pull the Cause Giving Interests...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleRevokeLogicalExpression(): void {
    this.includeTaxExemptRevoked = !this.includeTaxExemptRevoked;
  }
  trackLogicalExpression(logicalOperator: string): void {
    if (logicalOperator == 'AND') {
      this.logicalOperatorAnd = true;
      this.logicalOperatorOr = false;
    } else if (logicalOperator == 'OR') {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    } else {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    }
  }

  addCauseGivingInterestFilter(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if (addFlag) {
        this.donor_givingInterestsSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterests();
      } else {
        this.donor_givingInterestsWithoutSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterestsWithout();
      }
    }
  }

  recalculateListOfGivingInterests2(causingGivingInterest: string): void {
    if (this.donor_causeGivingInterestsList.length > 0) {
      if (this.logicalOperatorAnd && !this.logicalOperatorOr) {
        this.donor_causeGivingInterestsList.push("AND");
      } else if (!this.logicalOperatorAnd && this.logicalOperatorOr) {
        this.donor_causeGivingInterestsList.push("OR");
      } else {
        this.donor_causeGivingInterestsList.push("OR");
      }
    }
    this.donor_causeGivingInterestsList.push(causingGivingInterest);
  }

  recalculateListOfGivingInterestsWithout2(causingGivingInterest: string): void {
    this.donor_causeGivingInterestsWithoutList.push(causingGivingInterest);
  }

  addCauseGivingInterestFilter2(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if ('ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' == causeGivingInterestSelected) {
        return;
      }
      if (addFlag) {
        this.recalculateListOfGivingInterests2(causeGivingInterestSelected);
      } else {
        this.recalculateListOfGivingInterestsWithout2(causeGivingInterestSelected);
      }
    }
  }

  onDeleteGivingInterest(row: string): void {
    const index = this.donor_causeGivingInterestsList.indexOf(row);
    const size = this.donor_causeGivingInterestsList.length;
    const causeGivingInterestsListTemp: string[] = []
    if (size == 1) {
      this.donor_causeGivingInterestsList = [];
      return;
    }
    if (index == (size - 1) ) {
      let excludedSize: number = size - 2;
      let i = 0;
      while (i < excludedSize) {
        causeGivingInterestsListTemp.push(this.donor_causeGivingInterestsList[i]);
        i = i + 1;
      }
      this.donor_causeGivingInterestsList = causeGivingInterestsListTemp;
      return;
    }
    let i = 0;
    while (i < size) {
      if (index == 0 && i == 0 && size > 1) {
        //skip elements 0 and 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.donor_causeGivingInterestsList[i]);
      } else if (index == i && size > 1) {
        //skip elements i and i + 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.donor_causeGivingInterestsList[i]);
      } else {
        causeGivingInterestsListTemp.push(this.donor_causeGivingInterestsList[i]);
      }
      i = i + 1;
    }
    this.donor_causeGivingInterestsList = causeGivingInterestsListTemp;
  }

  onDeleteGivingInterestWithout(row: string): void {
    const index = this.donor_causeGivingInterestsWithoutList.indexOf(row);
    const size = this.donor_causeGivingInterestsWithoutList.length;
    const causeGivingInterestsWithoutListTemp: string[] = [];
    let i = 0;
    while (i < size) {
      if (i != index) {
        causeGivingInterestsWithoutListTemp.push(this.donor_causeGivingInterestsWithoutList[i]);
      }
      i = i + 1;
    }
    this.donor_causeGivingInterestsWithoutList = causeGivingInterestsWithoutListTemp;
  }

  recalculateListOfGivingInterests(): void {
    this.donor_causeGivingInterestsList = [];
    for (const givingInterest in this.donor_givingInterestsSetObj) {
      this.donor_causeGivingInterestsList.push(givingInterest);
    }
  }

  recalculateListOfGivingInterestsWithout(): void {
    this.donor_causeGivingInterestsWithoutList = [];
    for (const givingInterestWithout in this.donor_givingInterestsWithoutSetObj) {
      this.donor_causeGivingInterestsWithoutList.push(givingInterestWithout);
    }
  }

  recalculateObjOfGivingInterests(): void {
    this.donor_givingInterestsSetObj = {};
    for (const givingInterest in this.donor_causeGivingInterestsList) {
      this.donor_givingInterestsSetObj[givingInterest] = 1;
    }
  }
  recalculateObjOfGivingInterestsWithout(): void {
    this.donor_givingInterestsWithoutSetObj = {};
    for (const givingInterestWithout in this.donor_causeGivingInterestsWithoutList) {
      this.donor_givingInterestsWithoutSetObj[givingInterestWithout] = 1;
    }
  }

  deleteGivingInterestChip2(event: Event): void {
    // @ts-ignore
    //delete this.givingInterestsSetObj[event.target.value];
    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip2(event: Event): void {
    // @ts-ignore
    //delete this.givingInterestsWithoutSetObj[event.target.value];
    this.recalculateObjOfGivingInterestsWithout();
  }

  deleteGivingInterestChip3(row: any): void {
    let newList: any[] = [];
    for (const rowTemp of this.donor_causeGivingInterestsList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.donor_causeGivingInterestsList = newList;

    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip3(row: any): void {
    let newList: any[] = [];
    for (const rowTemp of this.donor_causeGivingInterestsWithoutList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.donor_causeGivingInterestsWithoutList = newList;

    this.recalculateObjOfGivingInterestsWithout();
  }

  onCancel() {
    this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
  }

  private submitDonorSearch(saveAndApplyFlag: boolean): boolean {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    let nonEmptyFilterFlag : boolean = false;
    let savedDonorSearchName: string = '';
    const savedDonorSearchNameEl = document.getElementById('donor-search-filter-name-text-id');
    // @ts-ignore
    const nameSelected = savedDonorSearchNameEl.value;
    if (nameSelected) {
      savedDonorSearchName = nameSelected;
      nonEmptyFilterFlag = true;
    } else {
      this.pageErrorMessages.push({
        field: 'Donor Search Name Error',
        detail: 'The Donor Search Name is required and must not exceed 50 characters.',
        severity: 'error'
      });
    }

    this.donor_names = [];
    const donorNamesEl = document.getElementById('donor-name-with-text-id');
    // @ts-ignore
    const donorNamesSelected = donorNamesEl.value;
    if (donorNamesSelected) {
      let cleanDonorNames: string =  this.apiService.trimLeadingTrailingSpaces(donorNamesSelected);
      if (cleanDonorNames.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Foundation Names characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let donorNamesFinal: string[] = cleanDonorNames.split(",");
      if (donorNamesFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Foundation Names limit exceeded. You are limited to 10 grant recipients.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < donorNamesFinal.length; i = i + 1) {
        this.donor_names.push(donorNamesFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }

    this.donor_namesWithout = [];
    /*
    const donorNamesWithoutEl = document.getElementById('donor-name-without-text-id');
    // @ts-ignore
    const donorNamesWithoutSelected = donorNamesWithoutEl.value;
    if (donorNamesWithoutSelected) {
      let cleanDonorNamesWithout: string =  this.apiService.trimLeadingTrailingSpaces(donorNamesWithoutSelected);
      if (cleanDonorNamesWithout.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Foundation Names characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let donorNamesWithoutFinal: string[] = cleanDonorNamesWithout.split(",");
      for (let i = 0; i < donorNamesWithoutFinal.length; i = i + 1) {
        this.donor_namesWithout.push(donorNamesWithoutFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }*/

    this.donor_eins = [];
    const einsEl = document.getElementById('donor-ein-text-id');
    // @ts-ignore
    const einsSelected = einsEl.value;
    if (einsSelected) {
      let cleanEins: string =  this.apiService.trimLeadingTrailingSpaces(einsSelected);
      if (cleanEins.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Eins characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let cleanEinsFinal: string[] = cleanEins.split(",");
      if (cleanEinsFinal.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Eins limit exceeded. You are limited to 10 eins.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < cleanEinsFinal.length; i = i + 1) {
        this.donor_eins.push(cleanEinsFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }

    this.donor_states = [];
    const usaStatesEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const usaStatesSelected = usaStatesEl.value;
    if (usaStatesSelected) {
      this.donor_states.push(usaStatesSelected);
      nonEmptyFilterFlag = true;
    }

    this.donatedGrantsStates = [];

    const donatedGrantsUsaStatesEl = document.getElementById('dg-usa-dropdown-list-id');
    // @ts-ignore
    const donatedGrantsUsaStatesSelected = donatedGrantsUsaStatesEl.value;
    if (donatedGrantsUsaStatesSelected) {
      this.donatedGrantsStates.push(donatedGrantsUsaStatesSelected);
      nonEmptyFilterFlag = true;
    }

    this.donor_cities = [];
    const citiesEl = document.getElementById('donor-cities-text-id');
    // @ts-ignore
    const citiesSelected = citiesEl.value;
    if (citiesSelected) {
      let cleanCities: string =  this.apiService.trimLeadingTrailingSpaces(citiesSelected);
      if (cleanCities.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let citiesFinal: string[] = cleanCities.split(",");
      for (let i = 0; i < citiesFinal.length; i = i + 1) {
        let finalCity = this.apiService.trimLeadingTrailingSpaces(citiesFinal[i])
        if (finalCity && !finalCity.startsWith(':')) {
          this.donor_cities.push(finalCity);
        }
      }
      nonEmptyFilterFlag = true;
    }

    this.donatedGrantsCities = [];

    const donatedGrantsCitiesEl = document.getElementById('donated-grants-cities-text-id');
    // @ts-ignore
    const donatedGrantsCitiesSelected = donatedGrantsCitiesEl.value;
    if (donatedGrantsCitiesSelected) {
      let cleanDonatedGrantsCities: string =  this.apiService.trimLeadingTrailingSpaces(donatedGrantsCitiesSelected);
      if (cleanDonatedGrantsCities.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Donated Grants Cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let cleanDonatedGrantsCitiesFinal: string[] = cleanDonatedGrantsCities.split(",");
      for (let i = 0; i < cleanDonatedGrantsCitiesFinal.length; i = i + 1) {
        this.donatedGrantsCities.push(cleanDonatedGrantsCitiesFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }

    this.taxYear = 0;
    const taxYearEl = document.getElementById('tax-year-dropdown-list-id');
    // @ts-ignore
    const taxYearSelected = taxYearEl.value;
    if (taxYearSelected) {
      this.taxYear = parseInt(taxYearSelected);
      nonEmptyFilterFlag = true;
    }


    this.donor_citiesWithout = [];
    /*
    const citiesWithoutEl = document.getElementById('donor-cities-without-text-id');
    // @ts-ignore
    const citiesWithoutSelected = citiesWithoutEl.value;
    if (citiesWithoutSelected) {
      let cleanCitiesWithout: string =  this.apiService.trimLeadingTrailingSpaces(citiesWithoutSelected);
      if (cleanCitiesWithout.length > 200) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cities characters limit exceeded. You are limited to 200 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      let citiesWithoutFinal: string[] = citiesWithoutSelected.split(",");
      for (let i = 0; i < citiesWithoutFinal.length; i = i + 1) {
        this.donor_citiesWithout.push(citiesWithoutFinal[i]);
      }
      nonEmptyFilterFlag = true;
    }*/

    this.donor_zipCodes = [];
    const zipCodesEl = document.getElementById('donor-zip-code-text-id');
    // @ts-ignore
    const zipCodesSelected = zipCodesEl.value;
    if (zipCodesSelected) {
      let cleanZipCodes: string =  this.apiService.trimLeadingTrailingSpaces(zipCodesSelected);
      if (cleanZipCodes.length > 20) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Zip Code characters limit exceeded. You are limited to 20 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      this.donor_zipCodes.push(cleanZipCodes);
      nonEmptyFilterFlag = true;
    }

    this.minYearsInBusiness = 0;
    /*
    const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    if (minYearsInBusinessEl) {
      if (this.minYearsInBusiness > 0) {
        // @ts-ignore
        this.minYearsInBusiness = parseInt(minYearsInBusinessEl.value);
        nonEmptyFilterFlag = true;
      }
    }*/
    this.includeTaxExemptRevoked = false;
    /*
    const includeTaxExemptRevokedEl = document.getElementById('flexRadioIncludeRevocationList');
    if (includeTaxExemptRevokedEl) {
      // @ts-ignore
      this.includeTaxExemptRevoked = includeTaxExemptRevokedEl.checked;
      nonEmptyFilterFlag = true;
    }*/

    this.donor_counties = [];
    /*
    const countiesEl = document.getElementById('donor-counties-text-id');
    // @ts-ignore
    const countiesSelected = countiesEl.value;
    console.log('countiesSelected: ' + JSON.stringify(countiesSelected));
    if (countiesSelected) {
      this.donor_counties.push(countiesSelected);
      nonEmptyFilterFlag = true;
    }
     */

    this.donor_countiesWithout = [];
    /*
    const countiesWithoutEl = document.getElementById('donor-counties-without-text-id');
    // @ts-ignore
    const countiesWithoutSelected = countiesWithoutEl.value;
    console.log('countiesWithoutSelected: ' + JSON.stringify(countiesWithoutSelected));
    if (countiesWithoutSelected) {
      this.donor_countiesWithout.push(countiesWithoutSelected);
      nonEmptyFilterFlag = true;
    }
    */

    this.donor_affiliationCodeIds = [];
    for (const affiliationCodeCheckboxTemp of this.donor_affiliationCodeCheckboxes) {
      if (affiliationCodeCheckboxTemp.checked === true) {
        this.donor_affiliationCodeIds.push(affiliationCodeCheckboxTemp.affiliationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_deductabilityCodeIds = [];
    for (const deductabilityCodeCheckboxTemp of this.donor_deductabilityCodeCheckboxes) {
      if (deductabilityCodeCheckboxTemp.checked === true) {
        this.donor_deductabilityCodeIds.push(deductabilityCodeCheckboxTemp.deductabilityCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_eoClassificationCodes = [];
    this.donor_eoSubsectionCodes = [];

    this.donor_filingReqCodeIds = [];
    for (const filingReqCodeCheckboxTemp of this.donor_filingReqCodeCheckboxes) {
      if (filingReqCodeCheckboxTemp.checked === true) {
        this.donor_filingReqCodeIds.push(filingReqCodeCheckboxTemp.filingReqCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_foundationCodeIds = [];
    for (const foundationCodeCheckboxTemp of this.donor_foundationCodeCheckboxes) {
      if (foundationCodeCheckboxTemp.checked === true) {
        this.donor_foundationCodeIds.push(foundationCodeCheckboxTemp.foundationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_nteeCodeIds = [];
    for (const nteeCodeCheckboxTemp of this.donor_nteeCodeCheckboxes) {
      if (nteeCodeCheckboxTemp.checked === true) {
        this.donor_nteeCodeIds.push(nteeCodeCheckboxTemp.nteeCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_nteeParentCodeIds = [];
    for (const nteeParentCodeCheckboxTemp of this.donor_nteeParentCodeCheckboxes) {
      if (nteeParentCodeCheckboxTemp.checked === true) {
        this.donor_nteeParentCodeIds.push(nteeParentCodeCheckboxTemp.nteeParentCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_organizationCodeIds = [];
    for (const organizationCodeCheckboxTemp of this.donor_organizationCodeCheckboxes) {
      if (organizationCodeCheckboxTemp.checked === true) {
        this.donor_organizationCodeIds.push(organizationCodeCheckboxTemp.organizationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_returnTypeCodeIds = [];
    for (const returnTypeCodeCheckboxTemp of this.donor_returnTypeCodeCheckboxes) {
      if (returnTypeCodeCheckboxTemp.checked === true) {
        this.donor_returnTypeCodeIds.push(returnTypeCodeCheckboxTemp.returnTypeCodeId);
        //nonEmptyFilterFlag = true;
      }
    }

    //Time Varying Parameters
    //Total Assets Range
    this.donor_totalAssetsRange = [];
    for (const totalAssetsRadioButtonTemp of this.donor_totalAssetsRadioButtons) {
      if (totalAssetsRadioButtonTemp.checked === true) {
        this.donor_totalAssetsRange.push(totalAssetsRadioButtonTemp.minTotalAssets);
        this.donor_totalAssetsRange.push(totalAssetsRadioButtonTemp.maxTotalAssets);
        nonEmptyFilterFlag = true;
      }
    }

    this.donor_totalIncomeRange = [];
    for (const totalIncomeRadioButtonTemp of this.donor_totalIncomeRadioButtons) {
      if (totalIncomeRadioButtonTemp.checked === true) {
        this.donor_totalIncomeRange.push(totalIncomeRadioButtonTemp.minTotalIncome);
        this.donor_totalIncomeRange.push(totalIncomeRadioButtonTemp.maxTotalIncome);
        nonEmptyFilterFlag = true;
      }
    }

    //Key Employees
    this.donor_keyStaff = [];
    const keyStaffEl = document.getElementById('donor-key-staff-text-id');
    // @ts-ignore
    const keyStaffSelected = keyStaffEl.value;
    if (keyStaffSelected) {
      let cleanKeyStaff: string =  this.apiService.trimLeadingTrailingSpaces(keyStaffSelected);
      if (cleanKeyStaff.length > 50) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Key Staff characters limit exceeded. You are limited to 50 characters.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      this.donor_keyStaff.push(cleanKeyStaff);
      nonEmptyFilterFlag = true;
    }

    if (this.donor_causeGivingInterestsList.length > 0) {
      if (this.donor_causeGivingInterestsList.length > 19) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cause Category Giving Interests limit exceeded. You are limited to 10 Cause Category Giving Interests.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
      nonEmptyFilterFlag = true;
    }

    if (this.donor_causeGivingInterestsWithoutList.length > 0) {
      if (this.donor_causeGivingInterestsWithoutList.length > 10) {
        this.pageErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cause Category Giving Interests limit exceeded. You are limited to 10 Cause Category Giving Interests.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        return false;
      }
    }

    const browserUrl: string = window.location.href;

    if (this.donor_names.length == 0 && this.donor_eins.length == 0 && this.donor_states.length == 0 && this.donor_cities.length == 0 &&
      this.donor_zipCodes.length == 0 && this.donor_affiliationCodeIds.length == 0 && this.donor_deductabilityCodeIds.length == 0 &&
      this.donor_eoClassificationCodes.length == 0 && this.donor_eoSubsectionCodes.length == 0 && this.donor_filingReqCodeIds.length == 0 &&
      this.donor_pfFilingReqCodeIds.length == 0 && this.donor_foundationCodeIds.length == 0 && this.donor_nteeCodeIds.length == 0 &&
      this.donor_nteeParentCodeIds.length == 0 && this.donor_organizationCodeIds.length == 0 && this.donor_totalAssetsRange.length == 0 &&
      this.donor_totalIncomeRange.length == 0 && this.donor_causeGivingInterestsList.length == 0 && this.donor_keyStaff.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
      this.pageErrorMessages.push({
        field: 'Donor Search Filter Error',
        detail: 'Non-empty Donor Search Name is required.',
        severity: 'error'
      });
    }

    if ((!nameSelected || nameSelected.length > 50) || !nonEmptyFilterFlag) {
      this.showPageErrorMessagesToUser();
      return false;
    }

    this.sortByCompanyNameAscId = 0;
    if (this.companyNameAscRadioButton) {
      this.sortByCompanyNameAscId = 1;
    } else if (this.companyNameDescRadioButton) {
      this.sortByCompanyNameAscId = 2;
    }

    this.sortByCityAscId = 0;
    if (this.cityAscRadioButton) {
      this.sortByCityAscId = 1;
    } else if (this.cityDescRadioButton) {
      this.sortByCityAscId = 2;
    }

    this.sortByStateAscId = 0;
    if (this.stateAscRadioButton) {
      this.sortByStateAscId = 1;
    } else if (this.stateDescRadioButton) {
      this.sortByStateAscId = 2;
    }

    this.sortByTotalAssetsAscId = 0;
    if (this.totalAssetsAscRadioButton) {
      this.sortByTotalAssetsAscId = 1;
    } else if (this.totalAssetsDescRadioButton) {
      this.sortByTotalAssetsAscId = 2;
    }

    const filter: SearchIDsCriteriaDto = {
      'names': this.donor_names,
      'namesWithout': this.donor_namesWithout,
      'eins': this.donor_eins,
      'states': this.donor_states,
      'cities': this.donor_cities,
      'citiesWithout': this.donor_citiesWithout,
      'zipCodes': this.donor_zipCodes,
      'includeTaxExemptRevoked': this.includeTaxExemptRevoked,
      'minYearsInBusiness': this.minYearsInBusiness,
      'donatedGrantsCities': this.donatedGrantsCities,
      'donatedGrantsStates': this.donatedGrantsStates,
      'taxYear': this.taxYear,
      'counties': this.donor_counties,
      'countiesWithout': this.donor_countiesWithout,
      'affiliationCodeIds': this.donor_affiliationCodeIds,
      'deductibilityCodeIds': this.donor_deductabilityCodeIds,
      'eoClassificationCodes': this.donor_eoClassificationCodes,
      'eoSubsectionCodes': this.donor_eoSubsectionCodes,
      'filingReqCodeIds': this.donor_filingReqCodeIds,
      'pfFilingReqCodeIds': this.donor_pfFilingReqCodeIds,
      'foundationCodeIds': this.donor_foundationCodeIds,
      'nteeCodeIds': this.donor_nteeCodeIds,
      'nteeParentCodeIds': this.donor_nteeParentCodeIds,
      'organizationCodeIds': this.donor_organizationCodeIds,
      'returnTypeCodeIds': this.donor_returnTypeCodeIds,
      'totalAssetsRange': this.donor_totalAssetsRange,
      'totalIncomeRange': this.donor_totalIncomeRange,
      'causes': this.donor_causes,
      'causeGivingInterests': this.donor_causeGivingInterestsList,
      'causeGivingInterestsWithout': this.donor_causeGivingInterestsWithoutList,
      'keyStaff': this.donor_keyStaff,
      'sortByCompanyNameAsc': this.sortByCompanyNameAscId,
      'sortByCityAsc': this.sortByCityAscId,
      'sortByStateAsc': this.sortByStateAscId,
      'sortByTotalAssetsAsc': this.sortByTotalAssetsAscId
    }

    //Submit to API
    // @ts-ignore
    this.executeSearch(browserUrl, savedDonorSearchName, JSON.stringify(filter), this.username, saveAndApplyFlag);
    return true;
  }

  executeSearch(browserUrl: string, savedSearchName: string, filter: string, username: string, saveAndApplyFlag: boolean): void {
    if (browserUrl.includes('create')) {
      const savedSearchDto: any = {
        savedSearchId: -1,
        userId: -1,
        savedSearchName: savedSearchName,
        searchTypeDto: {
          searchTypeId: this.searchTypeNameMap[this.searchTypeName],
          searchTypeName: this.searchTypeName
        },
        savedSearchJson: filter,
        createdTS: new Date(),
        updatedTS: new Date()
      }
      this.userService.addNewSavedSearch(savedSearchDto, username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            if (saveAndApplyFlag) {
              let expirationTimestamp: number = Date.now() + 1000*3600*2;
              localStorage.setItem('lastSearchDonorExpTime', expirationTimestamp.toString());
              localStorage.setItem('lastSearchDonor', this.currentSavedSearchDto.savedSearchJson);
              this.routerChild.navigateByUrl('app/search/donors');
            } else {
              this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
            }
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          if (err.error && err.error.limitReached == "Y"
            && err.error.currentAmount == err.error.limitAmount) {
            this.pageErrorMessages.push({
              field: 'Saved Searches Limit Reached',
              detail: 'Woah, woah! You have reached your limit of ' + err.error.limitAmount +' saved searches. Consider deleting some saved searches.',
              severity: 'error'
            });
          } else {
            this.pageErrorMessages.push({
              field: 'Donor Saved Search API Failure',
              detail: 'Failed to create the saved search name: ' + savedSearchDto.savedSearchName,
              severity: 'error'
            });
          }
          this.showPageErrorMessagesToUser();
        }
      );

    } else if (browserUrl.includes('edit')) {
      const savedSearchDto: any = {
        savedSearchId: this.currentSavedSearchDto.savedSearchId,
        userId: this.currentSavedSearchDto.userId,
        savedSearchName: savedSearchName,
        searchTypeDto: {
          searchTypeId: this.searchTypeNameMap[this.searchTypeName],
          searchTypeName: this.searchTypeName
        },
        savedSearchJson: filter,
        createdTS: this.currentSavedSearchDto.createdTS,
        updatedTS: this.currentSavedSearchDto.updatedTS
      }
      this.userService.editSavedSearch(savedSearchDto, username, this.impersonatedEmail).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.currentSavedSearchDto = result.body;
            if (saveAndApplyFlag) {
              //Expire 2 hours from now
              let expirationTimestamp: number = Date.now() + 1000*3600*2;
              localStorage.setItem('lastSearchDonorExpTime', expirationTimestamp.toString());
              localStorage.setItem('lastSearchDonor', this.currentSavedSearchDto.savedSearchJson);
              this.routerChild.navigateByUrl('app/search/donors');
            } else {
              this.routerChild.navigateByUrl('app/users/dashboard/saved-searches/all');
            }
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Donor Saved Search API Failure',
            detail: 'Failed to update the saved search name: ' + savedSearchDto.savedSearchName,
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    } else {
      this.pageErrorMessages.push({
        field: 'Saved Search API Failure',
        detail: 'Unknown Saved Search page...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    }
  }

  onSubmit(saveAndApplyFlag: boolean) {
    this.submitDonorSearch(saveAndApplyFlag);
  }

  openSearchTypeFilters(evt:any, searchTypeInput: string): void {
    this.searchTypeName = searchTypeInput;

    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      // @ts-ignore
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    // @ts-ignore
    document.getElementById(searchTypeInput).style.display = "block";
  }

  toggleCompanyNameAscButton(): void {
    this.companyNameAscRadioButton = !this.companyNameAscRadioButton;

    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = true;
      this.companyNameDescRadioButton = false;
    }
  }

  toggleCompanyNameDescButton(): void {
    this.companyNameDescRadioButton = !this.companyNameDescRadioButton;
    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = true;
    }
  }

  toggleCityAscButton(): void {
    this.cityAscRadioButton = !this.cityAscRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
    }
  }

  toggleCityDescButton(): void {
    this.cityDescRadioButton = !this.cityDescRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
    }
  }

  toggleStateAscButton(): void {
    this.stateAscRadioButton = !this.stateAscRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
    }
  }

  toggleStateDescButton(): void {
    this.stateDescRadioButton = !this.stateDescRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
    }
  }

  toggleTotalAssetsAscButton(): void {
    this.totalAssetsAscRadioButton = !this.totalAssetsAscRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = true;
      this.totalAssetsDescRadioButton = false;
    }
  }

  toggleTotalAssetsDescButton(): void {
    this.totalAssetsDescRadioButton = !this.totalAssetsDescRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = true;
    }
  }

  protected readonly event = event;
}
